'use client';

import { useGlobalContext } from '@/store/contexts/global-context';
import { resolveSwjTileProps } from '@/logic/games/resolve-swj-tile-props';
// eslint-disable-next-line nextjs-boundaries/no-server-import-in-client
import { GameFactoryCore, type GameFactoryProps } from './game-factory-core';
import { PRISMIC_ZONE_LAYOUT } from '@/app/constants/zone';

export const GameFactoryClient = (props: GameFactoryProps) => {
    const { isLoggedIn, isSiteWideJackpotEnabled, hideSwjTickers } = useGlobalContext();
    const layout = props.layout ?? PRISMIC_ZONE_LAYOUT.DEFAULT;
    const swj = resolveSwjTileProps({
        game: props.game,
        layout,
        isSiteWideJackpotEnabled,
        hideSwjTickers
    });

    return <GameFactoryCore {...props} layout={layout} isLoggedIn={isLoggedIn} swj={swj} />;
};
